import React from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd'
import deDE from 'antd/locale/de_DE';
import { useThemeStore } from 'shared-lib';

// Folgt dem Theme-Store wie BackgroundProvider; ohne gesetzten localStorage-Key bleibt das Portal dunkel.
export function AntdThemeProvider({ children }: { children: React.ReactNode }) {
    const { theme } = useThemeStore();

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: "#ffa200",
                },
                algorithm: theme === 'light' ? antdTheme.defaultAlgorithm : antdTheme.darkAlgorithm,
            }}
            locale={deDE}
        >
            {children}
        </ConfigProvider>
    )
}
